import React, {Component} from 'react';
import {Switch} from "react-router";
import {Route} from "react-router-dom";
import {compose} from "redux";
import {connect} from 'react-redux';
import {currentEffectiveUserId, searchState} from "../../../reducers/ui";
import {Button, Card, List} from "antd";
import {clearUserSearch, getUsersQuery} from "../../../actions/users";
import ContactSearch from "../../Boilerplate/ContactSearch";
import {addEmailsToContactList, addUserToContactList, removeUserFromContactList} from "../../../actions/contactlists";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {createSelector} from "reselect/es";
import {_UserInfoCustom} from "../../Boilerplate/UserInfoCustom";
import * as R from "ramda";
import {lowerOrNull, simpleSort, simpleSortNullsLast} from "../../../common/sorters";
import SearchBox from "../../Boilerplate/SearchBox";

class ListDetail extends Component {
  state = { searchTerm: null };

  handleSearch = searchTerm => this.setState({ searchTerm });

  render() {
    const { list: listinfo, onBack, onEdit, onAddUser, onDeleteUser } = this.props;
    let { listUsers } = this.props;
    const { searchTerm } = this.state;
    if (searchTerm) {
      const search = new RegExp(searchTerm, 'i');
      listUsers = listUsers.filter(contact => {
        // Extract searchable fields from user info object
        const obj = (({ name, emailaddress, companyname }) => ({ name, emailaddress, companyname }))(contact);
        return Object.values(obj)
          .map(i => search.test(i)) // Test search term against each field
          .filter(i => i).length; // Grab only results with one or more match
      });
    }
    listUsers.sort((a, b) => {
      const safetrim = a => a && typeof(a) === "string" ? a.trim() : a;
      let x = {
        a: { name: lowerOrNull(safetrim(a.name)), company: lowerOrNull(safetrim(a.companyname)), email: lowerOrNull(a.emailaddress), },
        b: { name: lowerOrNull(safetrim(b.name)), company: lowerOrNull(safetrim(b.companyname)), email: lowerOrNull(b.emailaddress), },
      }
      return simpleSortNullsLast(x.a.name ? x.a.company : null, x.b.name ? x.b.company : null,
        simpleSort(x.a.name, x.b.name,
          simpleSort(x.a.email, x.b.email)));
    });
    return <Card
      title={<h1 className={'nomargins'}>{listinfo.name}</h1>}
      extra={<Button.Group>
        <Button onClick={onBack} icon={'backward'}>Back</Button>
        <Button onClick={onEdit} icon={'edit'}>Edit</Button>
        <Button onClick={onAddUser} icon={'user-add'}>Add Contact</Button>
      </Button.Group>}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h3>{listinfo.description}</h3>
        <SearchBox
          placeholder="Search by name, company, or email"
          onChange={this.handleSearch}
          className='contact-search control-search'
          interactive
        />
      </div>
      <List
        dataSource={listUsers}
        renderItem={item => <List.Item
          actions={[<Button onClick={() => onDeleteUser(item.id)} icon={'user-delete'}>Delete</Button>]}>
          <List.Item.Meta title={<_UserInfoCustom resource={item} dataItems={['name', 'companyname', 'email']}/>}/>
        </List.Item>}
      />
    </Card>;
  }
}

const ListDetailRouter = props => {
  const _ListDetail = () => <ListDetail
    list={props.list}
    listUsers={props.listUsers}
    onBack={props.onBack}
    onEdit={props.onEdit}
    onAddUser={props.onAddUser}
    onDeleteUser={props.onDeleteUser}
  />;
  const _ContactSearch = () => <ContactSearch
    searchState={props.searchState}
    searchResults={props.searchResults}
    onSearchMount={props.onSearchMount}
    onSearch={props.onSearch}
    onInvite={props.onInvite(props.userId)}
    onEmailInvite={props.onEmailInvite(props.userId)}
    onBack={() => props.history.goBack()}
    extras={handleInvite => contact => contact['active'] ? contactCardExtras() :
      <Button icon={'user-add'} onClick={() => handleInvite(contact)}>Add User</Button>}
  />;
  return <Switch>
    <Route exact path="/settings/contact-lists/:listId" render={_ListDetail}/>
    <Route path="/settings/contact-lists/:listId/new" render={_ContactSearch}/>
  </Switch>;
};

const contactCardExtras = () => <React.Fragment>
  <Button icon={'user-add'} disabled>Added</Button>
</React.Fragment>;

const getDispatch = (dispatch) => dispatch;
const getHistory = (_, props) => props.history;
const getId = (_, props) => props.match.params.listId;

const getList = createSelector(
  state => state.view.data,
  getId,
  (contactlists, listId) => contactlists[listId] || {}
);

const getListUsers = state => R.path(['view', 'subview', 'data'], state) || {};

const listViewStateSelector = createSelector(getList, getListUsers, (list, listUsers) => ({ list, listUsers: Object.values(listUsers) }));

const listViewDispatchSelector = createSelector(
  [getDispatch, getHistory, getId],
  (dispatch, history, itemId) => ({
    onBack: () => history.push(`/settings/contact-lists`),
    onEdit: () => history.push(`/settings/contact-lists/${itemId}/edit`),
    onAddUser: () => history.push(`/settings/contact-lists/${itemId}/new`),
    onDeleteUser: id => dispatch(removeUserFromContactList(itemId, id)),
  })
);

const contactsViewDispatchSelector = createSelector(
  [(dispatch, _) => dispatch, getHistory, getId],
  (dispatch, history, itemId) => ({
    onSearchMount: () => dispatch(clearUserSearch()),
    onNewInvites: () => history.push(`/settings/contact-lists/${itemId}/new`),
    onSearch: (value) => dispatch(getUsersQuery(value)),
    onInvite: userId => contact => dispatch(addUserToContactList(userId, itemId, contact.contactuserid, () => history.goBack())),
    onEmailInvite: userId => emails => dispatch(addEmailsToContactList(userId, itemId, emails, () => history.goBack()))
  })
);

const mergedContacts = createSelector(
  getListUsers,
  state => state.ui.userSearchResults,
  (listContacts = {}, searchContacts) => searchContacts.map(id => listContacts[id] ? listContacts[id] : { contactuserid: id })
);

export default compose(
  connect(
    (state, props) => {
      if (!currentEffectiveUserId(state)) return { loading: true };
      return ({
        userId: currentEffectiveUserId(state),
        searchResults: mergedContacts(state, props),
        searchState: searchState(state, props),
        ...listViewStateSelector(state, props),
      });
    },
    (dispatch, props) => ({
      ...listViewDispatchSelector(dispatch, props),
      ...contactsViewDispatchSelector(dispatch, props),
    }),
  ),
  withLoading
)(ListDetailRouter)



// WEBPACK FOOTER //
// ./src/components/Settings/ContactLists/ListDetail.js